(function () {
  var DISMISS = 'sf-es-dismissed';
  var SUBSCRIBED = 'sf-es-subscribed';
  function get(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function set(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }

  function privacyVisible() {
    var sel = '#shopify-pc__banner, .shopify-pc__banner__dialog, [id*="cookie" i][role="dialog"], [class*="cookie-banner" i], [class*="consent-banner" i]';
    var nodes = document.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && getComputedStyle(nodes[i]).visibility !== 'hidden') return true;
    }
    return false;
  }
  function blockedRoute() { return /^\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname); }

  if (customElements.get('sf-email-signup')) return;
  customElements.define('sf-email-signup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.lastFocus = null;
      this._onClick = (e) => { if (e.target.closest('[data-sf-es-close]')) this.close(); };
      this._onCancel = (e) => { e.preventDefault(); this.close(); };
      this._onBackdrop = (e) => { if (e.target === this.dialog) this.close(); };
      this.dialog.addEventListener('click', this._onClick);
      this.dialog.addEventListener('click', this._onBackdrop);
      this.dialog.addEventListener('cancel', this._onCancel);

      var success = this.dataset.success === 'true';
      var result = this.dataset.result === 'true';
      if (success) set('localStorage', SUBSCRIBED, '1');
      // Server result (success or errors) always shown, never suppressed.
      if (result) { this.open(); return; }
      if (this.dataset.designMode === 'true') return;
      if (this.dataset.accepts === 'true' || blockedRoute()) return;
      if (get('localStorage', SUBSCRIBED) || get('sessionStorage', DISMISS)) return;
      var delay = Math.max(1, parseInt(this.dataset.delay, 10) || 5) * 1000;
      this.timer = setTimeout(() => this.tryOpen(), delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog) {
        this.dialog.removeEventListener('click', this._onClick);
        this.dialog.removeEventListener('click', this._onBackdrop);
        this.dialog.removeEventListener('cancel', this._onCancel);
        if (this.dialog.open) this.dialog.close();
      }
    }
    tryOpen() {
      if (get('sessionStorage', DISMISS) || get('localStorage', SUBSCRIBED)) return;
      if (privacyVisible() || document.querySelector('dialog[open]:not(.sf-es)')) {
        this.timer = setTimeout(() => this.tryOpen(), 2000);
        return;
      }
      this.open();
    }
    open() {
      if (this.dialog.open) return;
      this.lastFocus = document.activeElement;
      this.dialog.showModal();
      var target = this.dialog.querySelector('[aria-invalid="true"], input[type="email"]') || this.dialog.querySelector('[data-sf-es-close]');
      if (target) target.focus();
      if (location.hash === '#SfEmailSignup' && history.replaceState) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      }
    }
    close() {
      set('sessionStorage', DISMISS, '1');
      if (this.dialog.open) this.dialog.close();
      var f = this.lastFocus;
      if (f && typeof f.focus === 'function' && document.contains(f)) f.focus();
    }
  });

  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('sf-email-signup');
    if (el && el.dialog && !el.dialog.open) el.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('sf-email-signup');
    if (el && el.dialog && el.dialog.open) el.dialog.close();
  });
})();
